module.exports = __webpack_public_path__ + "static/media/dashboard_light.e3e28eb4.svg";